import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useFormikContext} from 'formik';
import {get} from 'lodash';
import {Row, Col} from 'react-bootstrap';
import {GreenButton} from '@styled';
import {MainLoader} from '@components';
import {sagaActions} from './redux/saga';

const FacilityDetails = ({facility}) => {
  const {values} = useFormikContext();
  const selectedCorporate = useSelector(
    (state) => state.dashboard.selectedCorporate
  );
  const loading = useSelector(
    (state) => state.dashboard.facilityDetails.loading
  );
  const facilityDetails = useSelector(
    (state) =>
      state.dashboard.facilityDetails.data.find(
        (item) => item.id === facility.id
      ) || null
  );
  const dispatch = useDispatch();
  useEffect(() => {
    // if (!facilityDetails) {
    dispatch({
      type: sagaActions.FETCH_OWNER_DASHBOARD_CORPORATE_FACILITY_DETAILS,
      payload: {
        corporateId: selectedCorporate.id,
        facilityId: facility.id,
        values: {
          reportYear: get(values, 'reportYear.value', ''),
          sector: get(values, 'reportSector.value', ''),
          sourceCategory: get(values, 'sourceCategory.value', ''),
          emissionSource: get(values, 'emissionSource.value', ''),
          fuelType: get(values, 'fuelType.value', ''),
          country: get(values, 'country.value', ''),
        },
      },
    });
    // }
  }, []);

  return (
    <div className="shadow-sm p-3 mb-5 bg-body rounded">
      {loading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <Row className="border-bottom mb-1 pb-1">
        <Col className="font-weight-bold">Source Category</Col>
        <Col className="font-weight-bold">Emission Source</Col>
        <Col className="font-weight-bold">Activity - fuel</Col>
        <Col className="font-weight-bold">Quantity(MMBtu)</Col>
        <Col className="font-weight-bold">Emission (t CO2)</Col>
      </Row>
      {facilityDetails &&
        facilityDetails.data.map((item) => {
          return (
            <Row key={`fac-dtls-${item.id}`} className="mb-1 pb-1">
              <Col>{item.sourceCategory}</Col>
              <Col>{item.emissionSource}</Col>
              <Col>{item.activity}</Col>
              <Col>{item.totalCo2}</Col>
              <Col>{item.totalEnergy}</Col>
            </Row>
          );
        })}
    </div>
  );
};

const Facility = ({data, reportYear}) => {
  const {facility, sector, scopeData} = data;
  const [showDetails, toggleShowDetails] = useState(false);
  return (
    <div className="mb-2">
      <Row>
        <Col>
          <GreenButton
            size="small"
            style={{padding: '0 5px'}}
            onClick={() => toggleShowDetails(!showDetails)}
          >
            <i
              className={showDetails ? 'fas fa-angle-up' : 'fas fa-angle-down'}
            />
          </GreenButton>{' '}
          {facility.name}
        </Col>
        <Col>{sector}</Col>
        <Col>{facility.country}</Col>
        <Col>{facility.city}</Col>
        <Col>{scopeData.scopes.scope1}</Col>
        <Col>{scopeData.scopes.scope2}</Col>
        <Col>{scopeData.scopeTotal}</Col>
        <Col>{scopeData.energyConsumed}</Col>
        <Col>{scopeData.energyProduced}</Col>
        <Col>{scopeData.netEnergyConsumed}</Col>
        <Col>{reportYear}</Col>
      </Row>
      {showDetails ? <FacilityDetails facility={facility} /> : null}
    </div>
  );
};

const OwnerDashboardCorporateFacilities = ({isActive}) => {
  const dispatch = useDispatch();
  const [isLoaded, setLoaded] = useState(false);
  const {values} = useFormikContext();

  const corporateFacilites = useSelector(
    (state) => state.dashboard.corporateFacilites
  );

  const selectedCorporate = useSelector(
    (state) => state.dashboard.selectedCorporate
  );

  useEffect(() => {
    if (isActive) {
      setLoaded(true);
    }
  }, [isActive]);

  useEffect(() => {
    if (isLoaded) {
      dispatch({
        type: sagaActions.FETCH_OWNER_DASHBOARD_CORPORATE_FACILITIES,
        payload: {
          corporateId: selectedCorporate.id,
          values: {
            reportYear: get(values, 'reportYear.value', ''),
            sector: get(values, 'reportSector.value', ''),
            sourceCategory: get(values, 'sourceCategory.value', ''),
            emissionSource: get(values, 'emissionSource.value', ''),
            fuelType: get(values, 'fuelType.value', ''),
            country: get(values, 'country.value', ''),
          },
        },
      });
    }
  }, [isLoaded, values, selectedCorporate]);

  return (
    <div>
      {corporateFacilites.loading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <Row className="border-bottom mb-2 pb-2 font-weight-bold">
        <Col>Facility</Col>
        <Col>Sector</Col>
        <Col>Country</Col>
        <Col>City</Col>
        <Col>Scope1 Emissions (t CO2)</Col>
        <Col>Scope2 Emissions (t CO2)</Col>
        <Col>Total Emissions (t CO2)</Col>
        <Col>Energy Consumed (MMBtu)</Col>
        <Col>Energy Produced (MMBtu)</Col>
        <Col>Energy Consumed Net (MMBtu)</Col>
        <Col>Reporting Year</Col>
      </Row>
      {!corporateFacilites.loading && corporateFacilites.data.length ? (
        corporateFacilites.data.map((rec) => (
          <Facility
            key={`fas-${rec.facility.id}`}
            data={rec}
            reportYear={get(values, 'reportYear.value', '')}
          />
        ))
      ) : (
        <Row>
          <Col>No data found!</Col>
        </Row>
      )}
    </div>
  );
};

export default OwnerDashboardCorporateFacilities;
